import script from "./UserSettingsView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSettingsView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__